import { Avatar, TableCell, TableRow } from '@mui/material';
import moment from 'moment';
import * as React from 'react';

import { TooltippedTruncatedText } from '~/components/TooltippedTruncatedText';
import { People } from '~/services/Http';

import { useSxStyles } from './useStyles';

export interface Props {
  tableRow: People.TimesheetShortDto;
  isTabDisabled?: boolean;
}

const handleRowClick = (empId: number) => {
  window.location.href = `/page-ui2-redirect?empId=${empId}&area=rewarding&subarea=REW_TIME_REPORTING`;
};

export const TeamMemberExtraHoursBalance: React.FC<Props> = ({
  tableRow,
  isTabDisabled,
}) => {
  const sxStyles = useSxStyles();
  const tableRowProps = isTabDisabled
    ? {
        hover: !isTabDisabled,
      }
    : {
        sx: sxStyles.row,
        onClick: () => handleRowClick(tableRow.employee.id),
        hover: !isTabDisabled,
      };

  return (
    <TableRow {...tableRowProps}>
      <TableCell sx={sxStyles.cell}>
        <Avatar
          alt={tableRow.employee.firstName}
          src={tableRow.employee.profilePic}
          data-cy="profile-pic"
        />
      </TableCell>
      <TableCell sx={sxStyles.cell}>
        <TooltippedTruncatedText dataCy="name">{`${tableRow.employee.firstName} ${tableRow.employee.lastName}`}</TooltippedTruncatedText>
      </TableCell>
      <TableCell align="right" sx={sxStyles.cell}>
        <span data-cy="extra-hours-balance">
          {!!tableRow.extraHoursBalance
            ? moment.duration(tableRow.extraHoursBalance).format('*h:mm')
            : '---'}
        </span>
      </TableCell>
    </TableRow>
  );
};
